// app/src/api/core/criticalApi.ts

import { createAxiosInstance } from "./axiosBase"
import { criticalLimitedRequest } from "./limiter"
import { addIdempotencyKey, preventDuplicateRequest } from "./idempotency"

/**
 * 중요한 API 요청을 위한 전용 Axios 인스턴스
 * visit, encounter 등 핵심 기능에 사용되며 우선순위 처리됨
 */
const baseCriticalApi = createAxiosInstance(15_000, 1000, "CriticalAPI")

/**
 * Critical API - 우선순위가 높은 API 요청용
 * 별도의 제한자(criticalApiLimit)를 사용하여 빠른 응답 보장
 * POST/PUT/PATCH 요청에는 Idempotency-Key 자동 추가
 */
export const criticalApi = {
  get: <T = any>(url: string, config?: any): Promise<any> => criticalLimitedRequest(() => baseCriticalApi.get<T>(url, config) as Promise<any>),

  post: <T = any>(url: string, data?: any, config?: any): Promise<any> =>
    preventDuplicateRequest("POST", url, data, () => {
      const configWithIdempotency = addIdempotencyKey(config, "POST")
      return criticalLimitedRequest(() => baseCriticalApi.post<T>(url, data, configWithIdempotency) as Promise<any>)
    }),

  put: <T = any>(url: string, data?: any, config?: any): Promise<any> =>
    preventDuplicateRequest("PUT", url, data, () => {
      const configWithIdempotency = addIdempotencyKey(config, "PUT")
      return criticalLimitedRequest(() => baseCriticalApi.put<T>(url, data, configWithIdempotency) as Promise<any>)
    }),

  patch: <T = any>(url: string, data?: any, config?: any, idempotencyKey?: string): Promise<any> =>
    preventDuplicateRequest("PATCH", url, data, () => {
      const configWithIdempotency = addIdempotencyKey(config, "PATCH", idempotencyKey)
      return criticalLimitedRequest(() => baseCriticalApi.patch<T>(url, data, configWithIdempotency) as Promise<any>)
    }),

  delete: <T = any>(url: string, config?: any): Promise<any> => criticalLimitedRequest(() => baseCriticalApi.delete<T>(url, config) as Promise<any>),
}
